import * as _ from "lodash";
import { IBusinessObject, IBusinessObjectCreateLoadOptions } from "../PA.Core/PA.Core.IF.BO";
import { IDateRange, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from "../PA.Core/PAdbContext";
import { IdentityProvider } from "../PA.Core/Basic/Identity";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import {
    WB_CBORow,
    WB_Published_ModelRow,
    WB_ProductGroupRow,
    WB_SpendFunctionRelationshipRow,
    WB_SimulationInputRow,
    WB_CBOConstraintRow,
    WB_CBOInputRelationshipRow,
    WB_CBOSetRow,
    WB_CBOSetItemRow,
    WB_ModelProfileRow,
    WB_CustomerRow,
    WB_CBOSetPredictorRow,
    WB_FinishedProductRow,
    WB_SpendFunctionRow,
    WB_SpendFunctionRelationshipScopeRow,
    WB_MasterDataSetRow,
    WB_SalesOrgRow, WB_ScenarioPlannerCustomerRow, WB_ScenarioPlannerProductPartitionRelRow
} from "../PA.Core/PAdbSchemaRows";
import { IHaveModel } from "../PA.Model.Core/PA.Model.IF.Aspects";

import {
    esWB_CBO,
    esWB_CBO_Input_Relationship,
    esWB_CBO_Constraint,
    esWB_Published_Model,
    esWB_User,
    esWB_Spend_Function_Relationship,
    esWB_Simulation_Input,
    esWB_CBO_Set,
    esWB_CBO_Set_Item,
    esWB_Model_Profile,
    esWB_MasterData_Set,
    esWB_SalesOrg,
    esWB_Customer_Hierarchy,
    esWB_Product_Hierarchy,
    esWB_Period_Hierarchy,
    esWB_CBO_Set_Predictor,
    esWB_Spend_Function,
    esWB_Simulation_Relationship,
    esWB_Spend_Function_Relationship_Scope,
    esWB_Simulation_Metrics,
    esWB_Simulation_Metrics_CBO_Set,
    esWB_Customer,
    esWB_Product_Group,
    esWB_Finished_Product,
    esWB_Spend_Function_Input_Relationship,
    esWB_Model_Profile_Group,
    esWB_Model_Profile_Group_Predictor,
    esWB_Model_Predictor, esWB_ScnPlannerCR, esWB_ScnPlannerPrdPPR, esWB_ScnPlannerPR, esWB_ScnPlanner
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { BehaviorSubject } from "rxjs";
import { ModelBO } from "../PA.Model.BusinessObjects/ModelBO";
import { ISimulationModel } from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import { ModelCoefficientSetBO } from "../PA.Model.BusinessObjects/ModelCoefficientSetBO";
import { IHaveCBOCalculator } from "../PA.Simulation.Services/CBOServices.IF";
import { ConstraintBasedOptimizerBOValidation } from "./ConstraintBasedOptimizerBOValidation";
import {
    CBOSetCreateOptions,
    IConstraintBasedOptimizer,
    IHaveCBOConstantInputs,
} from "../PA.Simulation.Core/PA.CBO.IF.Aspects";
import { ICBOCalculator } from "../PA.Simulation.Services/CBOServices.IF";
import { CBOCalculator } from "../PA.Simulation.Services/CBOCalculator";
import { IwbSpendFunctionRelationship } from "../PA.Core/PAdbSchemaRowsIF";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { IUsrContext } from "../PA.Core/PA.Core.IF.User";
import { EntityTypeUtils } from "../PA.MD.Entity/EntityTypeUtils";
import { CoefficientSetUtils, ICoefficientSetSubModel } from "../PA.Model.Core/CoefficientSetUtils";
import { ErrorMessage_restate, WarningMessage_restate } from "../PA.Core/Basic/MessageUtils";
import { IHaveSimulationFunctions } from "../PA.Simulation.Core/PA.FinancialModel.IF";

export interface ICBOCreateLoadOptions
    extends IBusinessObjectCreateLoadOptions {

    bScenarioPlannerInd?: boolean
    wbScnPlanId?: number
    wbScnPlannerId?: number
    wbScnPlannerPrdPrId?: number
    customerRows?: WB_CustomerRow[]
}

export class ConstraintBasedOptimizerBO
    implements
        IBusinessObject,
        IConstraintBasedOptimizer,
        IHaveModel,
        IHaveCBOCalculator,
        IHaveSimulationFunctions
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: ICBOCreateLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_CBO: WB_CBORow;

    arrModel: ISimulationModel[];

    constructor(options?: any) {
        this.CreateOptions = options || {};

        if ("dbContext" in this.CreateOptions) this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: "New CBO" });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider("Loading", this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_CBO = undefined;

        this.arrModel = [];

        this.IHaveModel_init();
        this.IConstraintBasedOptimizer_init();
        this.CustomerProducts_init();
        this.Workflow_init();
        this.IHaveCBOCalculator_init();
        this.IHaveCBOInputs_init();
      //  this.RefCounter_Init();
        this.ICBOSolver_init();
        this.IHaveSimulationFunctions_Init();
        this.SimulationInputs_init();
    }

    get WB_CBO(): WB_CBORow {
        return this.drWB_CBO;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: ICBOCreateLoadOptions): Promise<IBusinessObject> {
        const self = this;

        this.LoadProgressProvider.start("Creating CBO");
        const rv = (this._OnLoadComplete = (async () => {
            try {
                const opts = (self.LoadOptions = options || {});
                if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext;
                else self.dbContext = new PAdbContext();

                if (_.isEmpty(self.dbContext)) {
                    const sError = "Unable to determine dbContext for New CBO.";
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(sError);
                    return self;
                }

                const usrContext = <IUsrContext>PAEnvironment.getValue(PAEnvironment.UserContext);

                // Create record using dbContext
                const pm = <WB_Published_ModelRow>(
                    await self.dbContext.find(esWB_Published_Model, opts.wbPublishedModelId)
                );
                const mp = <WB_ModelProfileRow>await self.dbContext.find(esWB_Model_Profile, opts.wbModelProfileId);

                if (_.isEmpty(pm) || _.isEmpty(mp)) return self;

                const newCBORow = <WB_CBORow>await self.dbContext.createRecordWithKey(esWB_CBO);
                newCBORow.setDefaults();
                self.drWB_CBO = newCBORow;
                self.WB_CBO.cif.CBO_NAME = opts.sName || self.WB_CBO.cif.CBO_NAME;
                self.WB_CBO.cif.WB_MDSET_ID = opts.wbMasterDataSetId;
                self.WB_CBO.cif.WB_SALESORG_ID = opts.wbSalesOrgId;
                self.WB_CBO.cif.WB_PUBLISHED_MODEL_ID = opts.wbPublishedModelId;
                self.WB_CBO.cif.WB_MODEL_PROFILE_ID = opts.wbModelProfileId;
                self.WB_CBO.cif.WB_CUSTH_ID = opts.wbCustHId;
                self.WB_CBO.cif.WB_PRDH_ID = opts.wbPrdHId;
                self.WB_CBO.cif.WB_PERIODH_ID = opts.wbPeriodHId;
                self.WB_CBO.bScenarioPlannerInd = !!opts.bScenarioPlannerInd
                self.WB_CBO.cif.WB_SCNPLAN_ID = opts.wbScnPlanId || 0
                self.WB_CBO.cif.WB_SCNPLANNER_ID = opts.wbScnPlannerId || 0
                self.WB_CBO.cif.WB_SCNPLANNERPRDPR_ID = opts.wbScnPlannerPrdPrId || 0

                self.WB_CBO.cif.WB_AUTHUSR_ID_CREATEDBY = usrContext.User?.cif?.WB_AUTHUSR_ID || 0;
                self.dbContext.add(esWB_CBO, newCBORow);

                // Create record using dbContext
                const tasks: Promise<any>[] = [];
                if (opts.wbMasterDataSetId > 0)
                    tasks.push(
                        self.dbContext
                            .find(esWB_MasterData_Set, opts.wbMasterDataSetId)
                            .then((a: WB_MasterDataSetRow) => {
                                self.WB_CBO.WB_MasterDataSetRow = a;
                            }),
                    );
                if (opts.wbSalesOrgId > 0)
                    tasks.push(
                        self.dbContext.find(esWB_SalesOrg, opts.wbSalesOrgId).then((a: WB_SalesOrgRow) => {
                            self.WB_CBO.WB_SalesOrgRow = a;
                        }),
                    );
                if (opts.wbPublishedModelId > 0)
                    tasks.push(
                        self.dbContext
                            .find(esWB_Published_Model, opts.wbPublishedModelId)
                            .then((a: WB_Published_ModelRow) => {
                                self.WB_CBO.WB_PublishedModelRow = a;
                            }),
                    );
                if (opts.wbModelProfileId > 0)
                    tasks.push(
                        self.dbContext.find(esWB_Model_Profile, opts.wbModelProfileId).then((a: WB_ModelProfileRow) => {
                            self.WB_CBO.WB_ModelProfileRow = a;
                        }),
                    );
                if (opts.wbCustHId > 0) tasks.push(self.dbContext.find(esWB_Customer_Hierarchy, opts.wbCustHId));
                if (opts.wbPrdHId) tasks.push(self.dbContext.find(esWB_Product_Hierarchy, opts.wbPrdHId));
                if (opts.wbPeriodHId > 0) tasks.push(self.dbContext.find(esWB_Period_Hierarchy, opts.wbPeriodHId));

                self.WB_CBO.WB_UserRow_CreatedBy = usrContext.User;

                await Promise.all(tasks);

                await self._AfterBoLoadCompleteInternal();

                // If
                if(self.WB_CBO.bScenarioPlannerInd){
                    if(!_.isEmpty(opts.customerRows)) {
                        // Add Customer Scope
                        await self.addCBOSet({
                            setType: "CUSTOMER",
                            customerRows: opts.customerRows,
                        })
                    }
                }
                self.LoadProgressProvider.finish();
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err);
                throw err;
            }
        })());

        return rv;
    }

    Load(anId: number, options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            if (self.bIsLoaded) {
                const sError = "CBO Type already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null) self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                const sError = "Unable to determine dbContext for CBO.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = ConstraintBasedOptimizerBO.createRecordResolver({ dbContext: self.dbContext });
                recordResolverLoadPromise = ConstraintBasedOptimizerBO.setupRecordResolver(recordResolver, [anId]);
            }

            recordResolverLoadPromise
                .then(function () {
                    const newCBORow: any = recordResolver.get(esWB_CBO, anId);

                    if (_.isEmpty(newCBORow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_CBO = newCBORow;
                    return self._AfterBoLoadCompleteInternal();
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                    return;
                });
        });

        return this._OnLoadComplete;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        self.Identity.setAll(
            self.WB_CBO.cif.WB_CBO_ID,
            self.WB_CBO.cif.CBO_ID,
            self.WB_CBO.cif.CBO_NAME,
            self.WB_CBO.cif.WB_AUTHUSR_ID_CREATEDBY,
        );
        self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
        self.Identity.listenToRecordUpdates(self.WB_CBO, "WB_CBO_ID", "CBO_ID", "CBO_NAME");
        self.Identity.enableRecordWriteBack(self.WB_CBO, undefined, "CBO_NAME");
        self.Identity.mdset = self.WB_CBO.cif.WB_MDSET_ID;
        self.Identity.salesOrg = self.WB_CBO.cif.WB_SALESORG_ID;
        self.Identity.createdBy = self.WB_CBO.cif.WB_AUTHUSR_ID_CREATEDBY;

        self.LoadProgressProvider.setProgressMessage("CBO.Load", "Processing CBO Loaded Data");

        await self.SimulationInputs_onLoadComplete();
        await self.OnIHaveModelLoaded;
        await self.CustomerProducts_OnLoadComplete();
        await self.OnIHaveModelCoefficientSetLoaded;
        await self.IConstraintBasedOptimizer_OnLoadComplete();
        await self.IHaveCBOCalculator_OnLoadComplete();
        await self.OnIHaveCBOInputsLoaded;
        self.SyncScope();
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {
        const self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start(
            "Validating " + self.drWB_CBO.cif.CBO_NAME + "(" + self.drWB_CBO.cif.CBO_ID + ")",
        );
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                const sError = "Unable to determine dbContext to Validate CBO.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }
            ConstraintBasedOptimizerBOValidation.Validation(self)
                .then((ignore) => {
                    self._bIsValidated = self.ValidateMessageProvider.countMessages(MessageType.Error) == 0;
                    self.ValidateProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self._bIsValidated = false;
                    self.ValidateProgressProvider.exception(err);
                    resolve(self);
                });
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options);
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options);
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_CBO.cif.CBO_NAME + "(" + self.WB_CBO.cif.CBO_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                const sError = "Unable to determine dbContext to Save CBO";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.SaveOptions = options || {};

            let saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any,
            ) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            let bDone = false;

            self.Validate({}).then((ignore) => {
                if (!self.bIsValidated) {
                    self._bIsSaved = false;
                    bDone = true;
                    self.SaveProgressProvider.finish();
                    resolve(self);
                    return;
                }
                return saveFunction(esWB_CBO, self.drWB_CBO, {})
                    .then(() => {
                        const tasks: Promise<any>[] = [];
                        _.forEach(
                            self.drWB_CBO.WB_SpendFunctionRelationshipRows,
                            (aRow: IwbSpendFunctionRelationship) => {
                                for (const id in aRow) {
                                    if (id.includes("INPUT_VALUE_"))
                                        aRow[id] = aRow[id] == 0 ? 0 : Number(_.round(aRow[id], 2).toFixed(2));
                                }
                            },
                        );
                        tasks.push(
                            saveFunction(esWB_CBO_Input_Relationship, self.drWB_CBO.WB_CBOInputRelationshipRows),
                        );
                        tasks.push(saveFunction(esWB_CBO_Constraint, self.drWB_CBO.WB_CBOConstraintRows));
                        tasks.push(saveFunction(esWB_CBO_Set, self.drWB_CBO.WB_CBOSetRows));
                        tasks.push(
                            saveFunction(
                                esWB_CBO_Set_Item,
                                _.flatMap(self.drWB_CBO.WB_CBOSetRows, (a) => a.WB_CBOSetItemRows),
                            ),
                        );
                        tasks.push(
                            saveFunction(
                                esWB_CBO_Set_Predictor,
                                _.flatMap(self.drWB_CBO.WB_CBOSetRows, (a) => a.WB_CBOSetPredictorRows),
                            ),
                        );
                        tasks.push(
                            saveFunction(
                                esWB_Spend_Function_Relationship,
                                self.drWB_CBO.WB_SpendFunctionRelationshipRows,
                            ),
                        );
                        tasks.push(
                            saveFunction(
                                esWB_Spend_Function_Relationship_Scope,
                                _.flatMap(
                                    self.drWB_CBO.WB_SpendFunctionRelationshipRows,
                                    (a) => a.WB_SpendFunctionRelationshipScopeRows,
                                ),
                            ),
                        );
                        return Promise.all(tasks);
                    })
                    .then((ignored) => {
                        if (bBatch) {
                            self.dbContext.addBatchCompleteListener(() => {
                                self._bIsSaved = true;
                            });
                        } else {
                            self._bIsSaved = true;
                        }
                        self.SaveProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        self.SaveProgressProvider.exception(err);
                        reject(self);
                    });
            });
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options);
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options);
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start(
            "Deleting " + self.drWB_CBO.cif.CBO_NAME + "(" + self.drWB_CBO.cif.CBO_ID + ")",
        );

        return new Promise<IBusinessObject>((resolve, error) => {
            _.forEach(self.drWB_CBO.WB_CBOInputRelationshipRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted();
                }
            });
            _.forEach(self.drWB_CBO.WB_CBOConstraintRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted();
                }
            });

            _.forEach(self.drWB_CBO.WB_SpendFunctionXrefRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted();
                }
            });

            _.forEach(self.drWB_CBO.WB_CBOSetRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted();
                    _.forEach(aRow.WB_CBOSetItemRows, (a) => {
                        if (a.isActive) a.markDeleted();
                    });
                }
            });

            self.drWB_CBO.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self);
                    });
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "Simulation Inputs">
    // Previously, the input set was determined by the Simulation Type, which has been removed.
    private arrInputs: WB_SimulationInputRow[];

    private SimulationInputs_init() {
        this.arrInputs = [];
    }

    private async SimulationInputs_onLoadComplete() {
        const self = this;

        this.arrInputs = <WB_SimulationInputRow[]>await self.dbContext.findAll(esWB_Simulation_Input, {
            where: {
                DELETED_IND: { neq: "1" },
                SIMULATION_INPUT_TYPE: { inq: ["COGS", "VCM", "NetListPrice", "GrossListPrice", "FundRate"] },
            },
        });
    }

    //</editor-fold>

    //<editor-fold desc = "Published Model Products">

    private _bHasProductGroups: boolean;
    private _bHasProducts: boolean;
    private _allCustomers: WB_CustomerRow[];
    private _allProductGroups: WB_ProductGroupRow[];
    private _allProducts: WB_FinishedProductRow[];
    private _subModels: {
        Customer: WB_CustomerRow;
        ProductGroup: WB_ProductGroupRow;
        Product: WB_FinishedProductRow;
    }[];
    private _allSubModels: {
        Customer: WB_CustomerRow;
        ProductGroup: WB_ProductGroupRow;
        Product: WB_FinishedProductRow;
    }[];
    private _onCustomersChanged: BehaviorSubject<ConstraintBasedOptimizerBO>;
    private _onProductsChanged: BehaviorSubject<ConstraintBasedOptimizerBO>;

    private CustomerProducts_init() {
        this._bHasProductGroups = false;
        this._bHasProducts = false;
        this._allCustomers = [];
        this._allProductGroups = [];
        this._allProducts = [];
        this._allSubModels = [];
        this._onCustomersChanged = new BehaviorSubject<ConstraintBasedOptimizerBO>(undefined);
        this._onProductsChanged = new BehaviorSubject<ConstraintBasedOptimizerBO>(undefined);
    }

    private async CustomerProducts_OnLoadComplete(): Promise<void> {
        const self = this;

        //
        if (_.isEmpty(this.WB_CBO?.WB_PublishedModelRow)) return;

        const prdEntity = await EntityTypeUtils.getEntityTypeRow(
            this.WB_CBO.WB_PublishedModelRow.cif.WB_ENTITY_ID_PRODUCT,
        );

        if (_.isEmpty(prdEntity)) return;

        this._bHasProducts = prdEntity.cif.ENTITY_ID in { FinishedProduct: 0, ConsumerProduct: 1 };
        this._bHasProductGroups = !this._bHasProducts;

        const wbCoefSetId = this.WB_CBO?.WB_PublishedModelRow?.cif?.WB_MODEL_COEFF_SET_ID;

        const a = await CoefficientSetUtils.getCoefficientSetMasterData(wbCoefSetId, this.dbContext, true);
        this._allCustomers = a.Customers || [];
        this._allProducts = a.Products || [];
        this._allProductGroups = a.ProductGroups || [];
        this._allSubModels = a.SubModels || [];

        // Scenario Planner Filters
        // Customer by Optimization Scope
        // Products by Product Partition
        //
        if(this.WB_CBO.bScenarioPlannerInd) {
            if(self.WB_CBO.cif.WB_SCNPLANNER_ID > 0) {
                let plannerCustRels = <WB_ScenarioPlannerCustomerRow[]>await this.dbContext.findAll(esWB_ScnPlannerCR, {
                    WB_SCNPLANNER_ID: self.WB_CBO.cif.WB_SCNPLANNER_ID,
                    DELETED_IND: { neq: "1" },
                })
                let dctCust = _.keyBy(plannerCustRels, (a) => a.cif.WB_CUST_ID)
                this._allCustomers = _.filter(this._allCustomers, (c) => c.cif.WB_CUST_ID in dctCust)
            }
            if(self.WB_CBO.cif.WB_SCNPLANNERPRDPR_ID > 0){
                let plannerPrdRels = <WB_ScenarioPlannerProductPartitionRelRow[]>await this.dbContext.findAll(esWB_ScnPlannerPrdPPR, {where: {
                    WB_SCNPLANNERPRDPR_ID: self.WB_CBO.cif.WB_SCNPLANNERPRDPR_ID,
                    DELETED_IND: { neq: "1" }},
                })
                let dctPrdGrp = _.keyBy(plannerPrdRels, (a) => a.cif.WB_PRDGRP_ID)
                this._allProductGroups = _.filter(this._allProductGroups, (pg) => pg.cif.WB_PRDGRP_ID in dctPrdGrp)
            }
        }
    }

    get OnCustomersChanged(): BehaviorSubject<ConstraintBasedOptimizerBO> {
        return this._onCustomersChanged;
    }

    get OnProductsChanged(): BehaviorSubject<ConstraintBasedOptimizerBO> {
        return this._onProductsChanged;
    }

    get AllCustomers(): WB_CustomerRow[] {
        return this._allCustomers;
    }

    get AllProducts(): WB_FinishedProductRow[] {
        return this._allProducts;
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups;
    }

    //</editor-fold">

    //<editor-fold desc = "Data Entry Workflow">

    private _workflowChanged: BehaviorSubject<void>;
    private _workflowMessageProvider: MessageProvider;

    private Workflow_init() {
        this._workflowChanged = new BehaviorSubject(undefined);
        this._workflowMessageProvider = new MessageProvider();
    }

    get WorkflowChanged(): BehaviorSubject<void> {
        return this._workflowChanged;
    }

    get WorkflowMessageProvider(): MessageProvider {
        return this._workflowMessageProvider;
    }

    get bCoreSetsEditable(): boolean {
        return !this.WB_CBO.bMasterDataLockedInd;
    }

    get bCoreSetsComplete(): boolean {
        const self = this;

        const setTypes = _.groupBy(
            _.filter(self.WB_CBO.WB_CBOSetRows, (row) => row.isActive),
            (b) => b.cif.SET_TYPE,
        );

        if(self.WB_CBO.bScenarioPlannerInd)
            return "PRODUCT" in setTypes;
        else
            return "CUSTOMER" in setTypes && "PRODUCT" in setTypes && "START_DATE" in setTypes && "DURATION" in setTypes;
    }

    async ValidateCoreSets(): Promise<void> {
        const self = this;
        const mp = self._workflowMessageProvider;

        mp.clearMessages();

        if (!self.bCoreSetsComplete) {
            ErrorMessage_restate(mp, true, "Selections missing", "Main tab selections missing");
            return;
        }

        if(self.WB_CBO.bScenarioPlannerInd) {
            self.WB_CBO.bMasterDataLockedInd = true;
            self.WorkflowChanged.next(undefined);
            return
        }

        // Validate the Dates/ Duration vs Published Model
        const pm = self.WB_CBO.WB_PublishedModelRow;
        const publishedModelRange: IDateRange = {
            StartDt: pm.EffectiveStartDt,
            EndDt: pm.EffectiveEndDt,
        };

        const startDateSets = _.filter(self.WB_CBO.WB_CBOSetRows, (a) => a.isActive && a.cif.SET_TYPE == "START_DATE");
        const durationSets = _.filter(self.WB_CBO.WB_CBOSetRows, (a) => a.isActive && a.cif.SET_TYPE == "DURATION");

        const arrStartDate = _.map(
            _.filter(
                _.flatMap(startDateSets, (a) => a.WB_CBOSetItemRows),
                (b) => b.isActive,
            ),
            (c) => DateUtils.convertFromSAPBW(c.cif.START_DT),
        );
        const arrDuration = _.map(
            _.filter(
                _.flatMap(durationSets, (a) => a.WB_CBOSetItemRows),
                (b) => b.isActive,
            ),
            (c) => c.cif.DURATION,
        );

        // Find Start Dates that are outside the Published Model Period
        const arrStartDatesOutside = _.filter(arrStartDate, (a) => !DateUtils.InRange(a, publishedModelRange));
        const arrStartDatesInside = _.filter(arrStartDate, (a) => DateUtils.InRange(a, publishedModelRange));

        if (arrStartDatesOutside.length) {
            WarningMessage_restate(
                mp,
                true,
                "OutsideStartDts",
                `Start Dates outside Published Model Range ${DateUtils.formatRange(publishedModelRange)}: ${_.map(
                    arrStartDatesOutside,
                    (a) => DateUtils.formatDate(a),
                ).join(", ")}`,
            );
        }

        // Find the Durations that extend past the end of the Published Model
        const arrDurationsOutside: number[] = [];
        _.forEach(arrDuration, (dur) => {
            _.forEach(arrStartDatesInside, (startDt) => {
                const endDate = DateUtils.addDays(startDt, 7 * dur - 1);
                if (!DateUtils.InRange(endDate, publishedModelRange)) {
                    arrDurationsOutside.push(dur);
                    return false;
                }
            });
        });
        if (arrDurationsOutside.length) {
            WarningMessage_restate(
                mp,
                true,
                "OutsideDurations",
                `Durations (${arrDurationsOutside.join(
                    ", ",
                )}) produce End Dates outside Published Model Range ${DateUtils.formatRange(publishedModelRange)}`,
            );
        }

        self.WB_CBO.bMasterDataLockedInd = true;
        self.WorkflowChanged.next(undefined);
    }

    SyncScope(): void {
        const self = this;

        //sync function scope
        const validCustomers = _.map(self.SubModels, (model) => {
            return model.Customer.cif.WB_CUST_ID;
        });
        let validProducts: number[];
        if (self._bHasProducts)
            validProducts = _.map(self.SubModels, (model) => {
                return model?.Product?.cif?.WB_PROD_ID;
            });
        else
            validProducts = _.map(self.SubModels, (model) => {
                return model?.ProductGroup?.cif?.WB_PRDGRP_ID;
            });
        _.forEach(self.WB_CBO.WB_SpendFunctionRelationshipRows, (Rel) => {
            if (!Rel.isActive) return;
            _.forEach(Rel.WB_SpendFunctionRelationshipScopeRows, (scope) => {
                if (self._bHasProductGroups) {
                    if (
                        !(
                            scope.isActive &&
                            _.includes(validCustomers, scope.cif.WB_CUST_ID) &&
                            _.includes(validProducts, scope.WB_ProductGroupRow.cif.WB_PRDGRP_ID)
                        )
                    )
                        scope.markDeleted();
                }
                if (self._bHasProducts) {
                    if (
                        !(
                            scope.isActive &&
                            _.includes(validCustomers, scope.cif.WB_CUST_ID) &&
                            _.includes(validProducts, scope.WB_ProductRow.cif.WB_PROD_ID)
                        )
                    )
                        scope.markDeleted();
                }
            });
        });

        const shipmentGroups = _.groupBy(
            _.filter(self.SimulationFunctionRels, (row) => row.WB_SpendFunctionRow.cif.FUNCTION_TYPE == "Shipment"),
            "WB_SPEND_FUNCTION_ID",
        );
        _.forEach(shipmentGroups, (rel: any, group: string) => {
            if (shipmentGroups[group].length > 1) {
                _.forEach(shipmentGroups[group], (rel) => {});
            }
        });
    }

    async UnlockCoreSets(): Promise<void> {
        const self = this;
        const mp = self._workflowMessageProvider;

        mp.clearMessages();

        /*
        const purgeMetrics: WB_CBOMetricRow[] = []

        // Purge Results
        _.forEach(self.WB_CBO.WB_CBOMetricRows, (a) => {
            if (!a.isActive)
                return
            purgeMetrics.push(a)
            a.markDeleted()
        })

        await self.dbContext.Save(esWB_CBO_Metric, purgeMetrics)
        */

        self.WB_CBO.bMasterDataLockedInd = false;
        self.WorkflowChanged.next(undefined);
    }

    get bPredictorSetsEditable(): boolean {
        return this.WB_CBO.bMasterDataLockedInd;
    }

    get bPredictorSetsComplete(): boolean {
        const self = this;

        const modelProfileGrpIds = _.map(
            self.WB_CBO.WB_ModelProfileRow.WB_ModelProfileGroupRows,
            (a) => a.cif.WB_MODEL_PROFILEGR_ID,
        );

        const setTypes = _.map(
            _.filter(self.WB_CBO.WB_CBOSetRows, (row) => row.isActive && row.cif.SET_TYPE == "PREDICTOR"),
            (b) => b.cif.WB_MODEL_PROFILEGR_ID,
        );

        const setDifference = _.differenceWith(modelProfileGrpIds, setTypes);

        return setDifference.length == 0;
    }

    get bSpendEditable(): boolean {
        return this.WB_CBO.bMasterDataLockedInd;
    }

    get bConstraintsEditable(): boolean {
        return this.WB_CBO.bMasterDataLockedInd;
    }

    get bConstraintsVisible(): boolean {
        return true; //!this.WB_CBO.bScenarioPlannerInd;
    }

    get bExecutionEnabled(): boolean {
        return this.WB_CBO.bMasterDataLockedInd;
    }

    get bExecutionVisible(): boolean {
        return true;
    }

    get bResultsVisible(): boolean {
        return this.WB_CBO.bMasterDataLockedInd && !this.WB_CBO.bScenarioPlannerInd;
    }

    get bResultsEnabled(): boolean {
        return this.WB_CBO.bMasterDataLockedInd;
    }

    //</editor-fold">

    /*/<editor-fold desc = "IHaveRefCounter">

    private _refCounter: IRefCounter;
    private _refCounterSub: Subscription;

    RefCounter_Init(): void {
        this._refCounter = new RefCounter(this);
        this._refCounterSub = this.RefCounter.OnRefCounterChanged.subscribe(this.onRefCounterChanged.bind(this));
    }

    get RefCounter(): IRefCounter {
        return this._refCounter;
    }

    private onRefCounterChanged(event: { refCounter: IRefCounter; count: number }): void {
        if (this.RefCounter.RefCount > 0) return;

        if (_.isEmpty(this._cboCalculator)) return;

        this._cboCalculator.StopStatusLoop();
    }

    //</editor-fold>*/

    //<editor-fold desc = "Record Resolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const CBO_options: CreateOptions = {
            standardConditions: {
                [esWB_Simulation_Input]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Published_Model]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO_Input_Relationship]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO_Constraint]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO_Set]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO_Set_Item]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_CBO_Set_Predictor]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Spend_Function_Relationship]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Spend_Function_Relationship_Scope]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Simulation_Metrics]: { DELETED_IND: { notIn: ["1"], SUMMARY_LEVEL: "Customer" } },
                [esWB_Simulation_Metrics_CBO_Set]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Model_Profile_Group]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_ScnPlannerPR]: { DELETED_IND: { notIn: ["1"] } },
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Published_Model]: [esWB_User],
                [esWB_Spend_Function]: [esWB_Spend_Function_Input_Relationship],
                [esWB_Model_Profile_Group]: [esWB_Model_Profile_Group_Predictor],
                [esWB_Model_Profile_Group_Predictor]: [esWB_Model_Predictor],
                [esWB_ScnPlanner]: [esWB_ScnPlannerPR]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_CBO]: [esWB_Simulation_Metrics]
            }
        };

        return new ESRecordResolver(dbContext, CBO_options);
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_CBO, ids)
                .then((result) => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

    //<editor-fold desc = "BO operations">

    async createOrGetMetricConstraints(arrMetricIds: string[]): Promise<WB_CBOConstraintRow[]> {
        const self = this;
        const returnValue: WB_CBOConstraintRow[] = [];

        const dctByMetricId: { [metricId: string]: WB_CBOConstraintRow } = {};
        _.forEach(self.WB_CBO.WB_CBOConstraintRows, (aRow) => {
            if (!aRow.isActive) return;
            if (aRow.cif.METRIC_ID in dctByMetricId) {
                aRow.markDeleted();
                return;
            }

            dctByMetricId[aRow.cif.METRIC_ID] = aRow;
        });

        for (const aMetricId of arrMetricIds) {
            if (aMetricId in dctByMetricId) {
                returnValue.push(dctByMetricId[aMetricId]);
                continue;
            }

            const aNewRow = <WB_CBOConstraintRow>await self.dbContext.createRecordWithKey(esWB_CBO_Constraint);
            aNewRow.setDefaults();
            aNewRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
            aNewRow.cif.METRIC_ID = aMetricId;
            aNewRow.cif.ACTIVE_IND = "0";
            aNewRow.cif.MIN_VALUE = undefined;
            aNewRow.cif.MIN_VALUE = undefined;
            self.dbContext.add(esWB_CBO_Constraint, aNewRow);
            returnValue.push(aNewRow);
        }

        return returnValue;
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHaveModel_init() {
        this._bIHaveModelLoaded = false;
        this._OnIHaveModelLoaded = undefined;
        this._Model = undefined;
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded;
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this;

        if (self._OnIHaveModelLoaded) return self._OnIHaveModelLoaded;

        const returnValue = (self._OnIHaveModelLoaded = new Promise<void>((resolve, error) => {
            const wbModelId = self.WB_CBO.WB_PublishedModelRow.cif.WB_MODEL_ID;
            if (!(wbModelId > 0)) {
                error(`No Model Specified: ${wbModelId}`);
                return;
            }
            const aModel = new ModelBO();
            aModel
                .Load(wbModelId, { dbContext: self.dbContext })
                .then((ignore) => {
                    self._Model = aModel;
                    self._bIHaveModelLoaded = true;
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        }));

        return returnValue;
    }

    get Model(): ModelBO {
        return this._Model;
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModelCoefficientSet Operations">

    private _modelCoefficientSet: ModelCoefficientSetBO;
    private _OnIHaveModelCoefficientSetLoaded: Promise<void>;
    private _bIHaveModelCoefficientSetLoaded: boolean;

    IHaveModelCoefficientSet_init() {
        this._bIHaveModelCoefficientSetLoaded = false;
        this._OnIHaveModelCoefficientSetLoaded = undefined;
        this._modelCoefficientSet = undefined;
    }

    get bIHaveModelCoefficientSetLoaded(): boolean {
        return this._bIHaveModelCoefficientSetLoaded;
    }

    get OnIHaveModelCoefficientSetLoaded(): Promise<void> {
        const self = this;

        if (self._OnIHaveModelCoefficientSetLoaded) return self._OnIHaveModelCoefficientSetLoaded;

        const returnValue = (self._OnIHaveModelCoefficientSetLoaded = new Promise<void>((resolve, error) => {
            const wbModelCoefficientSetId = self.WB_CBO.WB_PublishedModelRow.cif.WB_MODEL_COEFF_SET_ID;
            if (!(wbModelCoefficientSetId > 0)) {
                error(`No Coeff Set Specified: ${wbModelCoefficientSetId}`);
                return;
            }
            const aModelCoefficientSet = new ModelCoefficientSetBO();
            aModelCoefficientSet
                .Load(wbModelCoefficientSetId, { dbContext: self.dbContext })
                .then((ignore) => {
                    self._modelCoefficientSet = aModelCoefficientSet;
                    self._bIHaveModelCoefficientSetLoaded = true;
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        }));

        return returnValue;
    }

    get ModelCoefficientSet(): ModelCoefficientSetBO {
        return this._modelCoefficientSet;
    }

    //</editor-fold>

    //<editor-fold desc="IHaveSimulationCalculator operations">

    private _cboCalculator: CBOCalculator;

    private IHaveCBOCalculator_init() {
        this._cboCalculator = new CBOCalculator();
    }

    private IHaveCBOCalculator_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self._cboCalculator.Register(self);
            resolve();
        });
    }

    get CBOCalculator(): ICBOCalculator {
        return this._cboCalculator;
    }

    private _solverMessageProvider: MessageProvider;
    private _solverProgressProvider: ProgressProvider;

    private ICBOSolver_init() {
        this._solverProgressProvider = new ProgressProvider("CBOSolve");
        this._solverMessageProvider = new MessageProvider();
        // this._solverTrialsChanged = new BehaviorSubject<ModelingSessionBO>(this);
    }

    get CBOSolverProgressProvider(): IProgressProvider {
        return this._solverProgressProvider;
    }

    get CBOSolverMessageProvider(): IMessageProvider {
        return this._solverMessageProvider;
    }

    CBOCalculatorOnSolvePress() {
        const self = this;
        self.CBOSolverMessageProvider.clearMessages();
        return new Promise((resolve, reject) => {
            self.CBOSolverProgressProvider.start("CBOSolving");
            const userContext: any = PAEnvironment.getValue(PAEnvironment.UserContext);

            self.Save()
                .then(() => {
                    return self.Reload();
                })
                .then(() => {
                    return self.CBOCalculator.Calculate({ wbAuthUsrId: userContext.User.cif.WB_AUTHUSR_ID });
                })
                .then(() => {
                    const e = { name: "CBOCalcSuccess", message: "CBOCalculation Completed" };
                    self.CBOSolverProgressProvider.finish();
                    self.CBOSolverMessageProvider.addMessage({
                        code: "CBOCalcSuccess",
                        type: MessageType.Information,
                        title: `${e.message}`,
                        description: "",
                        subtitle: "",
                        count: 0,
                    });
                    resolve(self);
                })
                .catch((err) => {
                    const e = { name: "CBOCalcError", message: "CBOCalculation failed" };
                    self.CBOSolverProgressProvider.exception(e);
                    self.CBOSolverMessageProvider.addMessage({
                        code: "CalcError",
                        type: MessageType.Error,
                        title: "Error in solving the CBO Solve",
                        description: `${e.message}`,
                        subtitle: "",
                        count: 0,
                    });
                    reject();
                });
        });
    }

    //</editor-fold>

    private _CBOSetCollectionChanged: BehaviorSubject<IConstraintBasedOptimizer>;

    private IConstraintBasedOptimizer_init() {
        this._CBOSetCollectionChanged = new BehaviorSubject<IConstraintBasedOptimizer>(undefined);
    }

    private async IConstraintBasedOptimizer_OnLoadComplete(): Promise<void> {
        const self = this;
    }

    //<editor-fold desc = "App CBOSet Operations">

    async addCBOSet(options: CBOSetCreateOptions): Promise<string> {
        const self = this;

        // first find out if record exists.
        let message: string = "";
        let bReturn = false;
        let keyCount: number = 0;
        const sets = self.CBOSets[options.setType];

        async function createSets(rows: any[]) {
            let SetIds: number[] = [];
            let ItemIds: number[] = [];
            if (options.setType != "PRODUCT") {
                SetIds = <number[]>await self.dbContext.getNewIds(esWB_CBO_Set, keyCount);
                ItemIds = <number[]>await self.dbContext.getNewIds(esWB_CBO_Set_Item, keyCount);
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    const aSetRow: WB_CBOSetRow = <WB_CBOSetRow>self.dbContext.createRecord(esWB_CBO_Set);
                    aSetRow.setDefaults();
                    const anItemRow: WB_CBOSetItemRow = <WB_CBOSetItemRow>(
                        self.dbContext.createRecord(esWB_CBO_Set_Item)
                    );
                    anItemRow.setDefaults();

                    aSetRow.cif.WB_CBO_SET_ID = SetIds[i];
                    aSetRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
                    aSetRow.WB_CBORow = self.WB_CBO;
                    aSetRow.cif.SET_TYPE = options.setType;

                    anItemRow.cif.WB_CBO_SET_ITEM_ID = ItemIds[i];
                    anItemRow.cif.WB_CBO_SET_ID = SetIds[i];
                    anItemRow.WB_CBOSetRow = aSetRow;
                    switch (options.setType) {
                        case "CUSTOMER":
                            aSetRow.cif.SET_ID = row.CUSTOMER_ID;
                            aSetRow.cif.SET_NAME = row.CUSTOMER_NAME;
                            anItemRow.cif.WB_CUST_ID = row.cif.WB_CUST_ID;

                            break;
                        case "START_DATE":
                            aSetRow.cif.SET_ID = row;
                            aSetRow.cif.SET_NAME =
                                row.substring(0, 4) + "-" + row.substring(4, 6) + "-" + row.substring(6, 8);
                            anItemRow.cif.START_DT = row;
                            break;
                        case "DURATION":
                            aSetRow.cif.SET_ID = row.toString();
                            aSetRow.cif.SET_NAME = row.toString();
                            anItemRow.cif.DURATION = row;
                            break;
                    }
                    self.dbContext.add(esWB_CBO_Set, aSetRow);
                    self.dbContext.add(esWB_CBO_Set_Item, anItemRow);
                }
            } else {
                ItemIds = <number[]>(
                    await self.dbContext.getNewIds(
                        esWB_CBO_Set_Item,
                        options?.productRows?.length || options?.productGroupRows?.length,
                    )
                );
                const aSetRow: WB_CBOSetRow = <WB_CBOSetRow>await self.dbContext.createRecordWithKey(esWB_CBO_Set);
                aSetRow.setDefaults();
                aSetRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
                aSetRow.WB_CBORow = self.WB_CBO;
                aSetRow.cif.SET_TYPE = options.setType;
                aSetRow.cif.SET_ID = options.setName;
                aSetRow.cif.SET_NAME = options.setName;
                self.dbContext.add(esWB_CBO_Set, aSetRow);

                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    const anItemRow: WB_CBOSetItemRow = <WB_CBOSetItemRow>(
                        self.dbContext.createRecord(esWB_CBO_Set_Item)
                    );
                    anItemRow.setDefaults();
                    anItemRow.cif.WB_CBO_SET_ITEM_ID = ItemIds[i];
                    anItemRow.cif.WB_CBO_SET_ID = aSetRow.cif.WB_CBO_SET_ID;
                    anItemRow.WB_CBOSetRow = aSetRow;
                    const pe = await EntityTypeUtils.getEntityTypeRow(
                        self.WB_CBO.WB_PublishedModelRow.cif.WB_ENTITY_ID_PRODUCT,
                    );
                    if (!_.isEmpty(pe) && _.includes(["FinishedProduct", "ConsumerProduct"], pe?.cif?.ENTITY_ID)) {
                        anItemRow.cif.WB_PROD_ID = row.WB_PROD_ID;
                    } else {
                        anItemRow.cif.WB_PRDGRP_ID = row.WB_PRDGRP_ID;
                    }
                    self.dbContext.add(esWB_CBO_Set_Item, anItemRow);
                }
            }
            self.WorkflowChanged.next();
        }

        switch (options.setType) {
            case "CUSTOMER": {
                if (_.isEmpty(options.customerRows)) return;
                keyCount = options.customerRows.length;
                const existingCustomers = _.filter(
                    self.WB_CBO.WB_CBOSetRows,
                    (row) =>
                        row.cif.SET_TYPE == "CUSTOMER" &&
                        row.isActive &&
                        _.includes(_.map(options.customerRows, "CUSTOMER_ID"), row.cif.SET_ID),
                );
                if (existingCustomers.length) {
                    message =
                        "Customer" +
                        (existingCustomers.length > 1 ? "s " : "  ") +
                        _.join(_.map(existingCustomers, "SET_NAME"), ", ") +
                        " already added. ";
                    if (existingCustomers.length == options.customerRows.length) {
                        bReturn = true;
                    } else {
                        keyCount = options.customerRows.length - existingCustomers.length;
                    }
                }
                if (bReturn) return message;

                const arrExisting: number[] = self.getSetDistinctKeys("CUSTOMER", "WB_CUST_ID", (a) => a > 0);
                const newCustomers = _.filter(options.customerRows, (row) => !_.includes(arrExisting, row.WB_CUST_ID));
                await createSets(newCustomers);
                break;
            }
            case "PRODUCT": {
                if (_.isEmpty(options.productRows) && _.isEmpty(options.productGroupRows)) return;
                keyCount = options?.productRows?.length || options?.productGroupRows?.length;

                const dctBySet = _.keys(sets);
                const existingProductSets: WB_CBOSetRow[] = [];
                if (!_.isEmpty(options.productRows)) {
                    _.forEach(dctBySet, (set: number) => {
                        if (
                            sets[set].items.length == options.productRows.length &&
                            !_.difference(
                                _.map(sets[set].items, "WB_PROD_ID"),
                                _.map(options.productRows, "WB_PROD_ID"),
                            ).length
                        ) {
                            existingProductSets.push(sets[set].row);
                        }
                    });
                    if (existingProductSets.length) {
                        message =
                            "Product set " +
                            _.join(_.map(existingProductSets, "PRODUCT_NAME"), ", ") +
                            " contains product selected. ";
                        bReturn = true;
                    }

                    if (bReturn) return message;

                    await createSets(options.productRows);
                }
                if (!_.isEmpty(options.productGroupRows)) {
                    _.forEach(dctBySet, (set: number) => {
                        if (
                            sets[set].items.length == options.productGroupRows.length &&
                            !_.difference(
                                _.map(sets[set].items, "WB_PRDGRP_ID"),
                                _.map(options.productGroupRows, "WB_PRDGRP_ID"),
                            ).length
                        ) {
                            existingProductSets.push(sets[set].row);
                        }
                    });

                    if (existingProductSets.length) {
                        message =
                            "Product Set " +
                            _.join(_.map(existingProductSets, "SET_NAME"), ", ") +
                            " contains product group selected. ";
                        bReturn = true;
                    }

                    if (bReturn) return message;

                    await createSets(options.productGroupRows);
                }
                break;
            }
            case "START_DATE": {
                if (_.isEmpty(options.startDates)) return;
                keyCount = options.startDates.length;
                const existingDates = _.filter(
                    self.WB_CBO.WB_CBOSetRows,
                    (row) =>
                        row.cif.SET_TYPE == "START_DATE" &&
                        row.isActive &&
                        _.includes(options.startDates, row.cif.SET_ID),
                );
                if (existingDates.length > 0) {
                    message =
                        "Start Date" +
                        (existingDates.length > 1 ? "s " : "  ") +
                        _.join(_.map(existingDates, "SET_NAME"), ", ") +
                        " already added.";
                    if (existingDates.length == options.startDates.length) {
                        bReturn = true;
                    } else {
                        keyCount = options.startDates.length - existingDates.length;
                    }
                }
                if (bReturn) return message;

                const arrExisting: string[] = self.getSetDistinctKeys("START_DATE", "START_DT", (a) => a > "0");

                const newDates = _.filter(options.startDates, (row) => !_.includes(arrExisting, row));
                await createSets(newDates);
                break;
            }
            case "DURATION": {
                if (_.isEmpty(options.durations)) return;
                keyCount = options.durations.length;
                const existingDurations = _.filter(
                    self.WB_CBO.WB_CBOSetRows,
                    (row) =>
                        row.cif.SET_TYPE == "DURATION" &&
                        row.isActive &&
                        _.includes(options.durations, Number(row.cif.SET_ID)),
                );
                if (existingDurations.length) {
                    message =
                        "Duration" +
                        (existingDurations.length > 1 ? "s " : "  ") +
                        _.join(_.map(existingDurations, "SET_NAME"), ", ") +
                        " already added. ";
                    if (existingDurations.length == options.durations.length) bReturn = true;
                    else keyCount = options.durations.length - existingDurations.length;
                }
                if (bReturn) {
                    return message;
                }
                const arrExisting: number[] = self.getSetDistinctKeys("DURATION", "DURATION", (a) => a > 0);

                const newDurations = _.filter(options.durations, (row) => !_.includes(arrExisting, row));
                await createSets(newDurations);
                break;
            }
            case "PREDICTOR": {
                if (_.isEmpty(options.groupPredictors)) return;

                keyCount = options.groupPredictors.length;
                await createSets(options.groupPredictors);
                break;
            }
        }

        return message;
    }

    async addCBOPredictorSet(options: CBOSetCreateOptions): Promise<string> {
        const self = this;
        const message: string = "";

        if (_.isEmpty(options.groupPredictors)) return;

        const rows = options.groupPredictors;
        const ItemIds = <number[]>await self.dbContext.getNewIds(esWB_CBO_Set_Item, rows.length);

        const aSetRow: WB_CBOSetRow = <WB_CBOSetRow>await self.dbContext.createRecordWithKey(esWB_CBO_Set);
        aSetRow.setDefaults();
        aSetRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
        aSetRow.WB_CBORow = self.WB_CBO;
        aSetRow.cif.SET_TYPE = options.setType;
        aSetRow.cif.SET_ID = options.setName;
        aSetRow.cif.SET_NAME = options.setName;
        aSetRow.cif.WB_MODEL_PROFILEGR_ID = options.groupWBId;
        aSetRow.cif.PRD_IND = options.prdInd;
        aSetRow.cif.CUST_IND = options.custInd;

        aSetRow.cif.MIN_VALUE = options.minValue;
        aSetRow.cif.MAX_VALUE = options.maxValue;
        aSetRow.cif.STEPS = options.steps;

        self.dbContext.add(esWB_CBO_Set, aSetRow);

        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const anItemRow: WB_CBOSetPredictorRow = <WB_CBOSetPredictorRow>(
                await self.dbContext.createRecord(esWB_CBO_Set_Predictor)
            );
            anItemRow.setDefaults();
            anItemRow.cif.WB_CBO_SET_PR_ID = ItemIds[i];
            anItemRow.cif.WB_CBO_SET_ID = aSetRow.cif.WB_CBO_SET_ID;
            anItemRow.WB_CBOSetRow = aSetRow;
            anItemRow.cif.WB_CUST_ID = row.WB_CUST_ID;

            if (self.WB_CBO.usesFinishedProducts) {
                anItemRow.cif.WB_PROD_ID = row.WB_PRD_ID;
            } else {
                anItemRow.cif.WB_PRDGRP_ID = row.WB_PRD_ID;
            }

            _.forEach(row.Predictors, (aPred) => {
                anItemRow.cif[aPred.PREDICTOR_ID] = aPred.Value;
            });
            self.dbContext.add(esWB_CBO_Set_Item, anItemRow);
        }
        self.WorkflowChanged.next();

        return message;
    }

    async removeCBORangeSets(options: CBOSetCreateOptions): Promise<void> {
        const self = this;

        _.forEach(self.WB_CBO.WB_CBOSetRows, (aSet: WB_CBOSetRow) => {
            if (aSet.isActive && aSet.cif.WB_MODEL_PROFILEGR_ID == options.groupWBId) {
                _.forEach(aSet.WB_CBOSetItemRows, (anItem) => anItem.markDeleted());
                aSet.markDeleted();
            }
        });

        self.WorkflowChanged.next();
    }

    async removeCBOSet(aCBOSetId: number): Promise<void> {
        const self = this;

        _.forEach(self.drWB_CBO.WB_CBOSetRows, (anCBOSetRow: WB_CBOSetRow) => {
            if (anCBOSetRow.isActive && anCBOSetRow.cif.WB_CBO_SET_ID == aCBOSetId) {
                anCBOSetRow.markDeleted();
                _.forEach(anCBOSetRow.WB_CBOSetItemRows, (anItemRow) => anItemRow.markDeleted());
            }
        });

        self.WorkflowChanged.next();
    }

    get CBOSets(): { [type: string]: { [set: number]: { items: WB_CBOSetItemRow[]; row: WB_CBOSetRow } } } {
        const self = this;

        const setTypes = _.groupBy(
            _.filter(self.WB_CBO.WB_CBOSetRows, (row) => row.isActive),
            (b) => b.cif.SET_TYPE,
        );

        const retVal: { [type: string]: { [set: number]: { items: WB_CBOSetItemRow[]; row: WB_CBOSetRow } } } = {};
        _.forEach(setTypes, (value, key) => {
            retVal[key] = {};
            _.forEach(value, (set) => {
                retVal[key][set.cif.WB_CBO_SET_ID] = {
                    row: set,
                    items: _.filter(set.WB_CBOSetItemRows, (i) => i.isActive),
                };
            });
        });

        return retVal;
    }

    getSetDistinctKeys(setType: string, fieldName: string, filter?: (value: any) => boolean): any[] {
        const self = this;
        const sets = _.filter(self.WB_CBO.WB_CBOSetRows, (a) => a.isActive && a.cif.SET_TYPE == setType);
        const dctValue: { [id: string]: any } = {};
        _.forEach(sets, (s) => {
            _.forEach(s.WB_CBOSetItemRows, (si) => {
                if (!si.isActive) return;

                // @ts-expect-error "dynamic column"
                const val: any = si?.[fieldName];

                if (!(val in dctValue)) dctValue[val] = val;
            });
        });
        let rv = _.values(dctValue);
        if (_.isFunction(filter)) rv = _.filter(rv, filter);
        return rv;
    }

    //</editor-fold>

    //<editor-fold desc="Reload">

    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, error) => {
            if (!self.bIsLoaded) {
                error("Reload: CBO not loaded");
                return;
            }

            const id = self.WB_CBO.cif.WB_CBO_ID;

            self.dbContext
                .purgeCache(esWB_CBO, self.WB_CBO, {})
                .then((ignore) => {
                    self._bIsLoaded = false;

                    self._OnLoadComplete = undefined;

                    return self.Load(id, { dbContext: self.dbContext });
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function");
                    }
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    async ReloadMetrics(): Promise<void> {
        const self = this;

        self.dbContext.purgeCache(esWB_Simulation_Metrics, self.WB_CBO.WB_SimulationMetricsRows);
        const rr = new ESRecordResolver(self.dbContext, {
            standardConditions: {
                [esWB_Simulation_Metrics]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_Simulation_Metrics_CBO_Set]: { DELETED_IND: { notIn: ["1"] } },
            },
        });

        await rr.queryAllWithRelationships(esWB_Simulation_Metrics, {
            where: {
                WB_CBO_ID: self.WB_CBO?.cif.WB_CBO_ID,
                SUMMARY_LEVEL: "Customer",
                DELETED_IND: { notIn: ["1"] },
            },
        });
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSimulationFunctions operations">

    private _OnSimulationFunctionsChanged: BehaviorSubject<{
        self: ConstraintBasedOptimizerBO;
        type: string;
        change?: any;
    }>;
    private _OnSimulationFunctionScopesChanged: BehaviorSubject<{
        self: ConstraintBasedOptimizerBO;
        type: string;
        change?: any;
    }>;

    private IHaveSimulationFunctions_Init(): void {
        this._subModels = [];
        this._OnSimulationFunctionsChanged = new BehaviorSubject<{
            self: ConstraintBasedOptimizerBO;
            type: string;
            change?: any;
        }>({
            self: undefined,
            type: "",
        });
        this._OnSimulationFunctionScopesChanged = new BehaviorSubject<{
            self: ConstraintBasedOptimizerBO;
            type: string;
            change?: any;
        }>({
            self: undefined,
            type: "",
        });
    }

    get SimulationFunctions(): WB_SpendFunctionRow[] {
        if (!(this.WB_CBO.cif.WB_MODEL_PROFILE_ID > 0)) return [];

        const profile: WB_ModelProfileRow = _.first(
            _.filter(
                this.Model.WB_Model.WB_ModelProfileRows,
                (row) => row.isActive && row.cif.WB_MODEL_PROFILE_ID == this.WB_CBO.cif.WB_MODEL_PROFILE_ID,
            ),
        );
        if (_.isEmpty(profile)) return [];

        const functionRows: WB_SpendFunctionRow[] = _.map(
            _.filter(profile.WB_ModelProfileSpendFunctionRows, (row) => row.isActive),
            (row) => {
                return row.WB_SpendFunctionRow;
            },
        );
        return functionRows;
    }

    get SimulationFunctionRels(): WB_SpendFunctionRelationshipRow[] {
        return _.filter(this.WB_CBO.WB_SpendFunctionRelationshipRows, (row) => row.isActive);
    }

    async addSimulationFunction(
        wbSpendFunctionId: number,
        opts: { [id: string]: any },
    ): Promise<WB_SpendFunctionRelationshipRow> {
        const self = this;
        let functionRow: WB_SpendFunctionRow = undefined;
        if (_.isEmpty(opts) || !(wbSpendFunctionId in opts)) {
            functionRow = <WB_SpendFunctionRow>await self.dbContext.find(esWB_Spend_Function, wbSpendFunctionId, {
                with: [esWB_Spend_Function_Input_Relationship],
            });
        } else {
            functionRow = opts[wbSpendFunctionId];
        }

        const newRow = <WB_SpendFunctionRelationshipRow>(
            await self.dbContext.createRecordWithKey(esWB_Spend_Function_Relationship)
        );
        newRow.setDefaults();
        newRow.cif.SPEND_ID = functionRow.cif.SPEND_FUNCTION_ID;
        newRow.cif.SPEND_NAME = functionRow.cif.SPEND_FUNCTION_NAME;
        newRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
        newRow.WB_CBORow = self.WB_CBO;
        newRow.cif.WB_SPEND_FUNCTION_ID = wbSpendFunctionId;
        newRow.WB_SpendFunctionRow = functionRow;
        if(functionRow.cif.FUNCTION_USAGE == 'Complex')
            newRow.cif.AMOUNT_LOCATION = 'Header'
        else
            newRow.cif.AMOUNT_LOCATION = functionRow.cif.AMOUNT_LOCATION;
        newRow.cif.RATE_UOM = 'ConsumerUnit'
        newRow.cif.REDEMPTION_PCNT = 1

        self.dbContext.add(esWB_Simulation_Relationship, newRow);
        this._OnSimulationFunctionsChanged.next({ self: self, type: opts.FunctionType, change: newRow });
        return;
    }

    async removeSimulationFunction(wbSpendFunctionRelationshipId: number, opts: { [id: string]: any }): Promise<void> {
        const self = this;
        _.forEach(self.WB_CBO.WB_SpendFunctionRelationshipRows, (row) => {
            if (row.isActive && row.cif.WB_SPEND_FUNCTIONR_ID == wbSpendFunctionRelationshipId) row.markDeleted();
        });
        this._OnSimulationFunctionsChanged.next({ self: self, type: opts.FunctionType });
        return;
    }

    async addSimulationFunctionSubModels(
        SpendFunctionRelRow: WB_SpendFunctionRelationshipRow,
        wbCustomerId: number,
        wbProdId?: number,
        wbPrdGrpId?: number,
        opts?: { [id: string]: any },
    ): Promise<WB_SpendFunctionRelationshipScopeRow> {
        const self = this;
        const newRow = <WB_SpendFunctionRelationshipScopeRow>(
            await self.dbContext.createRecordWithKey(esWB_Spend_Function_Relationship_Scope)
        );
        newRow.setDefaults();
        newRow.cif.WB_SPEND_FUNCTIONR_ID = SpendFunctionRelRow.cif.WB_SPEND_FUNCTIONR_ID;
        newRow.WB_SpendFunctionRelationshipRow = SpendFunctionRelRow;

        if(wbCustomerId > 0) {
            let customerRow: WB_CustomerRow = undefined;
            if (_.isEmpty(opts?.customer)) {
                customerRow = _.first(<WB_CustomerRow[]>await self.dbContext.findUsingCache(esWB_Customer, [wbCustomerId]));
            } else {
                customerRow = opts["customer"];
            }
            newRow.cif.WB_CUST_ID = wbCustomerId;
            newRow.WB_CustomerRow = customerRow;
        }

        if(wbPrdGrpId > 0) {
            let prdgrpRow: WB_ProductGroupRow = undefined;
            if (self._bHasProductGroups) {
                if (_.isEmpty(opts) || !("prdgrp" in opts)) {
                    prdgrpRow = _.first(
                        <WB_ProductGroupRow[]>await self.dbContext.findUsingCache(esWB_Product_Group, [wbPrdGrpId])
                    );
                } else {
                    prdgrpRow = opts["prdgrp"];
                }
                newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
                newRow.WB_ProductGroupRow = prdgrpRow;
            }
        }

        let prodRow: WB_FinishedProductRow = undefined;
        if (self._bHasProducts) {
            if (_.isEmpty(opts) || !("product" in opts)) {
                prodRow = _.first(
                    <WB_FinishedProductRow[]>await self.dbContext.findUsingCache(esWB_Finished_Product, [wbProdId])
                );
            } else {
                prodRow = opts["product"];
            }

            newRow.cif.WB_PROD_ID = wbProdId;
            newRow.WB_ProductRow = prodRow;
        }

        self.dbContext.add(esWB_Spend_Function_Relationship_Scope, newRow);
        self._OnSimulationFunctionScopesChanged.next({ self: self, type: opts.FunctionType, change: newRow });
        return;
    }

    async removeSimulationFunctionSubModel(
        wbSpendFunctionSubModelId: number,
        opts: { [id: string]: any },
    ): Promise<void> {
        const self = this;
        _.forEach(self.WB_CBO.WB_SpendFunctionRelationshipRows, (row) => {
            if (!row.isActive) return;
            _.forEach(row.WB_SpendFunctionRelationshipScopeRows, (sm) => {
                if (sm.isActive && sm.cif.WB_SPEND_FUNCTIONCPR_ID == wbSpendFunctionSubModelId) {
                    sm.markDeleted();
                    return;
                }
            });
        });
        self._OnSimulationFunctionScopesChanged.next({ self: self, type: opts.FunctionType });
        return;
    }

    // Need to get list of SubModels for Scoping Function
    get SubModels(): ICoefficientSetSubModel[] {
        const self = this;
        let items = _.flatMap(self.CBOSets["CUSTOMER"], (set) => set.items);
        const setCustomer = _.filter(self._allSubModels, (model) =>
            _.includes(_.map(items, "WB_CUST_ID"), model.Customer.cif.WB_CUST_ID),
        );
        items = _.flatMap(self.CBOSets["PRODUCT"], (set) => set.items);
        if (self._bHasProducts) {
            const setProduct = _.filter(setCustomer, (model) =>
                _.includes(_.map(items, "WB_PROD_ID"), model.Product.cif.WB_PROD_ID),
            );
            self._subModels = setProduct;
        } else {
            const setProductGroup = _.filter(setCustomer, (model) =>
                _.includes(_.map(items, "WB_PRDGRP_ID"), model.ProductGroup.cif.WB_PRDGRP_ID),
            );
            self._subModels = setProductGroup;
        }
        return this._subModels;
    } // Use Coefficient Set Utils

    get OnSimulationFunctionsChanged(): BehaviorSubject<{
        self: ConstraintBasedOptimizerBO;
        type: string;
        change?: any;
    }> {
        return this._OnSimulationFunctionsChanged;
    }

    get OnSimulationFunctionScopesChanged(): BehaviorSubject<{
        self: ConstraintBasedOptimizerBO;
        type: string;
        change?: any;
    }> {
        return this._OnSimulationFunctionScopesChanged;
    }

    //</editor-fold>

    //<editor-fold desc="Constant and Input operations ">

    private _bIHaveCBOInputsLoaded: boolean;
    private _OnIHaveCBOInputsLoaded: Promise<void>;
    private _CBOConstantInputsProgressProvider: ProgressProvider;
    private _OnCBOInputsCollectionChanged: BehaviorSubject<IHaveCBOConstantInputs>;
    private _CBOInputs_ProductGroups: WB_ProductGroupRow[];
    private _CBOConstant_ProductGroups: WB_ProductGroupRow[];

    IHaveCBOInputs_init() {
        this._bIHaveCBOInputsLoaded = false;
        this._OnCBOInputsCollectionChanged = new BehaviorSubject<IHaveCBOConstantInputs>(undefined);
        this._CBOConstantInputsProgressProvider = new ProgressProvider();
        this._CBOInputs_ProductGroups = [];
        this._CBOConstant_ProductGroups = [];
    }

    get bIHaveCBOInputsLoaded(): boolean {
        return this._bIHaveCBOInputsLoaded;
    }

    get OnIHaveCBOInputsLoaded(): Promise<void> {
        const self = this;

        if (self._bIHaveCBOInputsLoaded) {
            return ASync.resolve();
        }

        if (!_.isUndefined(self._OnIHaveCBOInputsLoaded)) {
            return self._OnIHaveCBOInputsLoaded;
        }
        const returnValue = new Promise<void>((resolve, error) => {
            const bDone = false;
            self.SyncProductGroups()
                .then((ignore) => {
                    if (bDone) {
                        return;
                    }
                    self._OnIHaveCBOInputsLoaded = undefined;
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
        self._OnIHaveCBOInputsLoaded = returnValue;
        return returnValue;
    }

    get OnCBOInputsCollectionChanged(): BehaviorSubject<IHaveCBOConstantInputs> {
        return this._OnCBOInputsCollectionChanged;
    }

    get CBOInputs(): WB_CBOInputRelationshipRow[] {
        return this.WB_CBO.WB_CBOInputRelationshipRows;
    }

    get CBOInputs_ProductGroups(): WB_ProductGroupRow[] {
        return this._CBOInputs_ProductGroups;
    }

    get CBOConstant_ProductGroups(): WB_ProductGroupRow[] {
        return this._CBOConstant_ProductGroups;
    }

    get CBOConstantInputsProgressProvider(): IProgressProvider {
        return this._CBOConstantInputsProgressProvider;
    }

    async SyncProductGroups(): Promise<void> {
        const self = this;

        const arrWbCustIds: number[] = self.getSetDistinctKeys("CUSTOMER", "WB_CUST_ID", (a) => a > 0);
        const arrWbPrdGrpIds: number[] = self.getSetDistinctKeys("PRODUCT", "WB_PRDGRP_ID", (a) => a > 0);
        const arrWbProdIds: number[] = self.getSetDistinctKeys("PRODUCT", "WB_PROD_ID", (a) => a > 0);
        const dctWbCustId = _.keyBy(arrWbCustIds, (a) => a);

        let subModels = _.filter(self._allSubModels, (a) => a.Customer.cif.WB_CUST_ID in dctWbCustId);

        let dctWbPrdId: { [wbId: number]: number } = {};

        if (self._bHasProducts) {
            dctWbPrdId = _.keyBy(arrWbProdIds, (a) => a);
            subModels = _.filter(subModels, (a) => a.Product?.cif?.WB_PROD_ID in dctWbPrdId);
        }
        if (self._bHasProductGroups) {
            dctWbPrdId = _.keyBy(arrWbPrdGrpIds, (a) => a);
            subModels = _.filter(subModels, (a) => a.ProductGroup?.cif?.WB_PRDGRP_ID in dctWbPrdId);
        }

        const dctSM: {
            [wbCustId: number]: {
                [wbPrdId: number]: {
                    Customer: WB_CustomerRow;
                    ProductGroup: WB_ProductGroupRow;
                    Product: WB_FinishedProductRow;
                };
            };
        } = {};
        _.forEach(subModels, (sm) => {
            const wbCustId = sm.Customer.cif.WB_CUST_ID;
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = sm.Product.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = sm.ProductGroup.cif.WB_PRDGRP_ID;
            if (!(wbPrdId > 0)) return;

            if (!(wbCustId in dctSM)) dctSM[wbCustId] = {};

            if (!(wbPrdId in dctSM[wbCustId])) dctSM[wbCustId][wbPrdId] = sm;
        });

        // Index Existing, Purge dups, out of scope
        const dctInputs: { [wbCustId: number]: { [wbPrdId: number]: WB_CBOInputRelationshipRow } } = {};

        _.forEach(self.WB_CBO.WB_CBOInputRelationshipRows, (aRow) => {
            if (!aRow.isActive) return;
            const wbCustId = aRow.cif.WB_CUST_ID;
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = aRow.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = aRow.cif.WB_PRDGRP_ID;

            if (!(wbPrdId > 0)) {
                aRow.markDeleted();
                return;
            }

            // Check for SubModel scope
            if (!(wbCustId in dctSM)) {
                aRow.markDeleted();
                return;
            }

            if (!(wbCustId in dctInputs)) dctInputs[wbCustId] = {};

            // Check for SubModel scope
            if (!(wbPrdId in dctInputs[wbCustId])) {
                dctInputs[wbCustId][wbPrdId] = aRow;
            } else {
                // Remove duplicate
                aRow.markDeleted();
            }
        });

        // Add Missing SubModels
        for (const wbCustIdx in dctSM) {
            const wbCustId = +wbCustIdx;
            for (const wbPrdIdx in dctSM[wbCustIdx]) {
                const wbPrdId = +wbPrdIdx;

                const sm = dctSM[wbCustIdx][wbPrdIdx];

                // Check if record exists, if not create it.
                if (!(wbCustId in dctInputs)) dctInputs[wbCustId] = {};

                if (wbPrdId in dctInputs[wbCustId]) continue;

                // Create Missing Record
                const newRec = <WB_CBOInputRelationshipRow>(
                    await self.dbContext.createRecordWithKey(esWB_CBO_Input_Relationship)
                );
                newRec.cif.WB_CUST_ID = wbCustId;
                newRec.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID;
                newRec.WB_CBORow = self.WB_CBO;
                if (self._bHasProducts) {
                    newRec.cif.WB_PROD_ID = wbPrdId;
                    newRec.WB_ProductRow = sm.Product;
                }
                if (self._bHasProductGroups) {
                    newRec.cif.WB_PRDGRP_ID = wbPrdId;
                    newRec.WB_ProductGroupRow = sm.ProductGroup;
                }
                self.dbContext.add(esWB_CBO_Input_Relationship, newRec);
                dctInputs[wbCustId][wbPrdId] = newRec;
            }
        }
    }

    getStartDayCount(): number {
        const self = this;
        const rows = [];
        //Number of start dates
        const startDate = DateUtils.convertFromSAPBW(self.WB_CBO.cif.START_DT);
        const endDate = DateUtils.convertFromSAPBW(self.WB_CBO.cif.END_DT);
        return self.countStartDate(startDate, endDate);
    }

    countStartDate(start: any, end: any): number {
        if (end < start) return; //avoid infinite loop;
        let count: number = 0;
        for (count; start <= end; start.setDate(start.getDate() + 1)) {
            if (start.getDay() == 5) count++;
        }
        return count;
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(
    ConstraintBasedOptimizerBO,
    "ConstraintBasedOptimizerBO",
    "Constraint Based Optimizer",
);
